import React from 'react';
import { Grid, Box, TextField } from '@mui/material';
import FormLabelWithIcon from './FormLabelWithIcon';
import { multilineTextInputSx } from './inputStyles';

export function FreeTextArea({
  intl,
  value,
  onChange,
  classes = {},
  labelKey = 'gpt-recommendation-free-text-default-label',
  required = false
}) {
  return (
    <Grid className={classes?.sectionContainer || ''}>
      <FormLabelWithIcon
        iconName="FileText"
        labelText={intl.formatMessage({ id: labelKey })}
        type="blue"
        required={required}
      />
      <Box style={{ width: '100%' }}>
        <TextField
          variant="outlined"
          placeholder={intl.formatMessage({ id: 'gpt-news-matching-free-text-placeholder' })}
          fullWidth
          multiline
          minRows={2}
          value={value}
          onChange={event => onChange('freeText', event.target.value, value)}
          slotProps={{ input: { sx: multilineTextInputSx } }}
        />
      </Box>
    </Grid>
  );
}
export default FreeTextArea;
